import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Draggable } from 'react-beautiful-dnd';

import EditButton from './Edit/Button';
import DeleteButton from './Delete/Button';

export default function TableItem({ affiliateTrainingStep, index }) {
  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    opacity: isDragging ? 0.5 : 1,
    ...draggableStyle,
  });

  return (
    <Draggable draggableId={affiliateTrainingStep.id} index={index}>
      {(provided, snapshot) => (
        <li
          className="list-group-item"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style,
          )}
        >
          <Row>
            <Col md={10}>
              <i className="fa fa-bars mr10" />
              {affiliateTrainingStep.attributes.title}
            </Col>

            <Col md={2} className="text-right">
              <EditButton affiliateTrainingStep={affiliateTrainingStep} />
              <DeleteButton affiliateTrainingStep={affiliateTrainingStep} />
            </Col>
          </Row>
        </li>
      )}
    </Draggable>
  );
}

TableItem.propTypes = {
  affiliateTrainingStep: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};
